module.exports = __webpack_public_path__ + "static/iid-share-dc53212f2f39d5b4b499b7fb18038d15.jpg";